module.exports = __webpack_public_path__ + "img/icon_boat.91a76e0a.png";